import getConfig from 'next/config';

import {getApiRequest, postApiRequest} from '~/src/utilities/feed/api.js';
import {getLoginState} from '~/src/utilities/helpers/login';
import {LoginState} from '~/src/utilities/constants/login';
import {CommentSortColumn, CommentSortDirection} from '~/src/utilities/constants/api';
import {Logger} from '~/src/utilities/helpers/log';

const {publicRuntimeConfig: config} = getConfig();

const createComment = async (contentId, parentId, authorNickname, body, responseToken) => {
    const data = {
        tenantId: Number(config.tenantId),
        contentId,
        parentId,
        authorNickname,
        body,
        responseToken
    };

    try {
        return await postApiRequest(config.comment.service.comments, data);
    } catch (error) {
        if (error.statusCode === 422) {
            return await error.raw.json();
        }

        Logger.info(`[${error.name}][Comment] Error while creating comment`, {error});
    }
};

const getComments = async (id, {limit = 10, sortBy = CommentSortColumn.CREATED_AT, sortOrder = CommentSortDirection.DESC} = {}) => {
    try {
        return await getApiRequest(
            `${config.feeds.comment}?tenantId=${config.tenantId}&contentId=${id}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`
        );
    } catch (error) {
        Logger.info(`[${error.name}][Comment] Error while fetching comments`, {error, id, limit, sortBy, sortOrder});
    }
};

const escalateComment = async (id, escalationText) => {
    const data = {
        data: {
            type: 'escalation',
            attributes: {
                message: escalationText
            }
        }
    };
    try {
        const escalateURL =
            (await getLoginState()) === LoginState.ACCOUNT
                ? `${config.comment.escalateCommentUrl}/${id}/escalations`
                : `${config.comment.escalateAnonymousCommentUrl}/${id}/escalations`;
        return await postApiRequest(escalateURL, data, true);
    } catch (error) {
        Logger.info(`[${error.name}][Comment] Error while escalating comment`, {error, id, escalationText});
    }
};

const validateComment = async (authorNickname, body) => {
    const data = {
        tenantId: Number(config.tenantId),
        authorNickname,
        body
    };
    try {
        await postApiRequest(config.comment.service.validate, data);
        return {isValid: true};
    } catch (error) {
        if (error.statusCode === 422) {
            return {
                ...(await error.raw.json()),
                isValid: false
            };
        }

        Logger.info(`[${error.name}][Comment] Error while validating comment`, {error, authorNickname, body});
    }
};

export {createComment, getComments, escalateComment, validateComment};
